
import { useLocation } from "@/services";
import { ILocation } from "@/types";
import { defineComponent, computed } from "vue";
import SavedSearchItem from "./SavedSearchItem.vue";
export default defineComponent({
  components: {
    SavedSearchItem,
  },
  setup() {
    const savedLocations = computed(
      () => useLocation().savedLocations as ILocation[]
    );
    return { savedLocations };
  },
});
